import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SlownikService} from '../../../../../../../shared/services/slownik/slownik.service';
import {NavigationService} from '../../../../../../../shared/services/navigation/navigation.service';
import {SlownikUszkodzen} from '../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import {LokalizacjaUszkodzenia} from '../../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';
import {Store} from '@ngrx/store';
import {
  FormularzUszkodzenService
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz-uszkodzen.service';
import {BaseLokalizacjaUszkodzenComponent} from '../base-lokalizacja-uszkodzen.component';
import {FormControl, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {isNumeric, max, min} from '../../../../../../../shared/validators/ControlValidators';
import {
  ParametryPowierzchni,
  ParametryZbioruUszkodzen
} from '../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {
  UszkodzeniaWLokalizacjiComponent
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/lokalizacja/uszkodzenia-w-lokalizacji.component';
import {SlownikRodzajElementu} from '../../../../../../../shared/model/rodzaj-elementu/slownikRodzajElementu';

@Component({
  selector: 'app-pomieszczenie',
  templateUrl: './pomieszczenie.component.html'
})

export class PomieszczenieComponent extends BaseLokalizacjaUszkodzenComponent implements OnInit {
  @ViewChildren(UszkodzeniaWLokalizacjiComponent) uszkodzenia!: QueryList<UszkodzeniaWLokalizacjiComponent>;

  private readonly RODZAJ_ELEMENTU = SlownikRodzajElementu.POMIESZCZENIE;

  public MINIMALNY_WYMIAR!: number;
  public MAKSYMALNY_WYMIAR!: number;
  private nazwaUszkodzenia!: string;


  ngOnInit(): void {
    super.ngOnInit()
    this.slownikRodzajuElementu();
  }

  private slownikRodzajuElementu(): void {
    const {szerokosc, wysokosc, dlugosc} = this.formularzLokalizacjiUszkodzenia.controls;
    this.pobierzSlownikRodzajuElementow(
      this.RODZAJ_ELEMENTU,
      {
        next: (rodzajElementu => {
          this.MINIMALNY_WYMIAR = rodzajElementu.minimalnyWymiar;
          this.MAKSYMALNY_WYMIAR = rodzajElementu.maksymalnyWymiar;
          if (szerokosc && wysokosc && dlugosc) {
            szerokosc.setValidators(this.numberValidationFunction());
            wysokosc.setValidators(this.numberValidationFunction());
            dlugosc.setValidators(this.numberValidationFunction())
            szerokosc.updateValueAndValidity();
            wysokosc.updateValueAndValidity();
            dlugosc.updateValueAndValidity();
          }
        })
      }
    );
  }

  get slownikUszkodzen(): SlownikUszkodzen[] {
    return [
      SlownikUszkodzen.SUFIT,
      SlownikUszkodzen.SCIANA_WEWNETRZNA,
      SlownikUszkodzen.PODLOGA,
      SlownikUszkodzen.LISTWY_PRZYPODLOGOWE,
      SlownikUszkodzen.SKRZYDLO_DRZWIOWE,
      SlownikUszkodzen.OSCIEZNICA_DRZWIOWA,
      SlownikUszkodzen.SZYBA_W_DRZWIACH,
      SlownikUszkodzen.DRZWI_WEWNETRZNE,
      SlownikUszkodzen.SZYBA_W_OKNIE_PAKIET_DWUSZYBOWY,
      SlownikUszkodzen.SZYBA_W_OKNIE_PAKIET_TRZYSZYBOWY
    ];
  }

  get lokalizacjaUszkodzen(): LokalizacjaUszkodzenia {
    return LokalizacjaUszkodzenia.pobierz(this.nazwaUszkodzenia);
  }

  constructor(route: ActivatedRoute, store: Store, navigation: NavigationService,
              formularzUszkodzenService: FormularzUszkodzenService,
              slownikService: SlownikService) {
    super(route, store, navigation, formularzUszkodzenService, slownikService);
    // ToDo - Wykorzystanie innego mechanizmu pobierania ścieżki z route?
    this.nazwaUszkodzenia = route.snapshot.url[0].path;
  }

  iniciujFormularz(): void {
    this.formularzLokalizacjiUszkodzenia = this.czyDataRemontuWymagana ? new UntypedFormGroup({
      szerokosc: this.getFormControlWithNumberValidation(null),
      dlugosc: this.getFormControlWithNumberValidation(null),
      wysokosc: this.getFormControlWithNumberValidation(null),
      dataRemontu: this.getFormControlWithDateValidation(null)
    }) : new UntypedFormGroup({
      szerokosc: this.getFormControlWithNumberValidation(null),
      dlugosc: this.getFormControlWithNumberValidation(null),
      wysokosc: this.getFormControlWithNumberValidation(null)
    });
  }

  zapiszUszkodzeniazPodformularzy(): void {
    const parametry = {} as ParametryZbioruUszkodzen;
    parametry.szerokoscPomieszczenia = this.formularzLokalizacjiUszkodzenia.controls.szerokosc.value;
    parametry.dlugoscPomieszczenia = this.formularzLokalizacjiUszkodzenia.controls.dlugosc.value;
    parametry.wysokoscPomieszczenia = this.formularzLokalizacjiUszkodzenia.controls.wysokosc.value;
    if (this.czyDataRemontuWymagana) {
      parametry.dataRemontu = this.formularzLokalizacjiUszkodzenia.controls.dataRemontu.value;
    }

    const uszkodzeniaPojedyncze = this.utworzUszkodzeniaPojedyncze<ParametryPowierzchni>(this.uszkodzenia.toArray());
    const uszkodzeniaGrupowe = this.utworzUszkodzeniaGrupowe<ParametryPowierzchni>(this.uszkodzenia.toArray());

    const uszkodzenia = uszkodzeniaPojedyncze.concat(uszkodzeniaGrupowe)
    uszkodzenia.forEach(u => u.rodzajElementu = this.RODZAJ_ELEMENTU)
    this.utworzLubAktualizujZbiorUszkodzen(parametry, uszkodzenia);
  }

  inicjujIstniejaceUszkodzeniaDoEdycji(): void {
    super.inicjujIstniejaceUszkodzeniaDoEdycji()
    setTimeout(() => {
      if (this.zbiorUszkodzen) {
        this.formularzLokalizacjiUszkodzenia.controls.szerokosc.setValue(this.zbiorUszkodzen.parametry.szerokoscPomieszczenia);
        this.formularzLokalizacjiUszkodzenia.controls.dlugosc.setValue(this.zbiorUszkodzen.parametry.dlugoscPomieszczenia);
        this.formularzLokalizacjiUszkodzenia.controls.wysokosc.setValue(this.zbiorUszkodzen.parametry.wysokoscPomieszczenia);
      }
    })
  }

  private getFormControlWithNumberValidation(param: number | null): FormControl<number | null> {
    return new FormControl<number | null>(param, this.numberValidationFunction());
  }

  private numberValidationFunction(): ValidatorFn[] {
    return [
      Validators.required,
      min(this.MINIMALNY_WYMIAR),
      max(this.MAKSYMALNY_WYMIAR),
      isNumeric()
    ]
  }
}
